import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { ThemeProvider } from "./Theme/ThemeAppContext";
import { LanguageProvider } from "./Translate/useLanguageContext";
import { AppToaster } from "../../Templates/_UI/Alerts/AppToaster";
import { CONFIG_PLUGIN } from "../../../_Config/Plugins/_Config.Plugin";
import { UserAuthenticatedProvider } from "./_Auth/userAuthenticatedContext";


export const AppProviders = ({ children }) => {

    let CONTENT = (
        <>
            {children}
            <AppToaster />
        </>
    );

    if (CONFIG_PLUGIN.CONTEXTS.HAS__USER_AUTH_CONTEXT) {
        CONTENT = <UserAuthenticatedProvider>{CONTENT}</UserAuthenticatedProvider>;
    }

    if (CONFIG_PLUGIN.CONTEXTS.HAS__ROUTING_CONTEXT) {
        CONTENT = <BrowserRouter>{CONTENT}</BrowserRouter>;
    }

    if (CONFIG_PLUGIN.CONTEXTS.HAS__TRANSLATE_CONTEXT) {
        CONTENT = <LanguageProvider>{CONTENT}</LanguageProvider>;
    }

    if (CONFIG_PLUGIN.CONTEXTS.HAS__THEME_CONTEXT) {
        CONTENT = <ThemeProvider>{CONTENT}</ThemeProvider>;
    }

    if (CONFIG_PLUGIN.CONTEXTS.HAS__TRACKING_META_SEO) {
        CONTENT = <HelmetProvider>{CONTENT}</HelmetProvider>;
    }

    return CONTENT;
};